import { moveItem } from "lib/array/array";
import {
  getDielineBandMoveIndex,
  orderDielineGuidesAboveRegularElements
} from "lib/dielineGuides";

const DesignLayerOps = {
  changeElementPosition({ elementId, groupId, pageId, moveAction }) {
    let updatedDesignData = this;

    if (groupId) {
      updatedDesignData = this.changeElementPositionInGroup({
        elementId,
        groupId,
        moveAction
      });
    } else {
      updatedDesignData = this.changeElementPositionInPage({
        elementId,
        pageId,
        moveAction
      });
    }

    // check if the element is a background element
    const element = this.getElement(elementId);
    if (element.type === "background") {
      // Background element should be set to foreground
      const designWithRemovedBackground =
        this.setElementAsForeground(elementId);

      // we should keep the updated background element but use page and group ordering from the move function
      updatedDesignData = new this.constructor({
        ...updatedDesignData,
        elements: {
          ...updatedDesignData.elements,
          [elementId]: designWithRemovedBackground.elements[elementId]
        },
        version: this.version + 1
      });
    }

    return updatedDesignData;
  },

  changeElementPositionInGroup({ elementId, groupId, moveAction }) {
    const group = this.getElement(groupId);

    const elementIndex = group.elementsOrder.indexOf(elementId);

    const newIndex = getDielineBandMoveIndex({
      elementIds: group.elementsOrder,
      elementId,
      moveAction,
      designData: this
    });

    const groupElementsOrderUpdated = orderDielineGuidesAboveRegularElements(
      moveItem(group.elementsOrder, elementIndex, newIndex),
      this
    );

    const elementsUpdated = {
      ...this.elements,
      [groupId]: {
        ...group,
        elementsOrder: groupElementsOrderUpdated
      }
    };

    return new this.constructor({
      ...this,
      elements: elementsUpdated,
      version: this.version + 1
    });
  },

  changeElementPositionInPage({ elementId, pageId, moveAction }) {
    const page = this.pages[pageId];

    const elementIndex = page.elementsOrder.indexOf(elementId);

    const newIndex = getDielineBandMoveIndex({
      elementIds: page.elementsOrder,
      elementId,
      moveAction,
      designData: this
    });

    const pageElementsOrderUpdated = orderDielineGuidesAboveRegularElements(
      moveItem(page.elementsOrder, elementIndex, newIndex),
      this
    );

    const pagesUpdated = {
      ...this.pages,
      [pageId]: {
        ...page,
        elementsOrder: pageElementsOrderUpdated
      }
    };

    return new this.constructor({
      ...this,
      pages: pagesUpdated,
      version: this.version + 1
    });
  }
};

export default DesignLayerOps;
